export { default } from './Card.view';
export type { ICard, TitleWithContentAndId } from './Card.types';
